import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { styled } from 'styled-components';

import { formatDateAndTime } from '../../utils/dates';

const CreateOrderConfirmationModal = ({ actionHandler, closeHandler, data, show, isSubmitting }) => {
    // Extraer los datos del objeto
    const { requestDate, vehiclePlate, requestingUser, maintenanceType, observations, odometer } = data;

    // ----- Actions
    const handleClose = () => {
        closeHandler();
    };

    const handleAction = () => {
        actionHandler();
    };

    // ----- Render
    return (
        <Modal show={show} size='lg' backdrop='static' centered onHide={handleClose}>
            <Modal.Header className='fw-bold' closeButton>
                Confirmación de Orden de Trabajo
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Fecha de solicitud:</label>
                    <p>{formatDateAndTime(requestDate)}</p>
                </div>
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Vehículo:</label>
                    <p>{vehiclePlate}</p>
                </div>
                {/* Campo de kilometraje - Solo se muestra si viene en los datos */}
                {odometer && (
                    <div className='d-flex'>
                        <label className='fw-bold me-3'>Kilometraje:</label>
                        <p>{odometer} km</p>
                    </div>
                )}
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Solicitante:</label>
                    <p>{requestingUser}</p>
                </div>
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Tipo de mantenimiento:</label>
                    <p>{maintenanceType}</p>
                </div>
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Observaciones:</label>
                    <p>{observations || '--'}</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <p className='fw-bold me-3'>¿Desea crear la orden de trabajo?</p>
                <CancelButton onClick={handleClose}>Cancelar</CancelButton>
                <ConfirmButton onClick={handleAction} disabled={isSubmitting}>
                    {isSubmitting ? (
                        <>
                            <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                            Creando...
                        </>
                    ) : (
                        'Confirmar'
                    )}
                </ConfirmButton>
            </Modal.Footer>
        </Modal>
    );
};

const CancelButton = styled(Button)`
    background-color: #a5a7a0;
    border-color: #a5a7a0;

    &:hover {
        background-color: #a5a7a0;
        border-color: #a5a7a0;
    }
`;

const ConfirmButton = styled(Button)`
    background-color: #d04437;
    border-color: #d04437;

    &:hover {
        background-color: #b73d32;
        border-color: #b73d32;
    }

    &:disabled {
        background-color: #6c757d;
        border-color: #6c757d;
    }

    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
    }
`;

export default CreateOrderConfirmationModal;
